import {IHeaderParams} from 'ag-grid-community';
import {InventoryQualityTableColumns} from '../../components/my-brand-screen/types';
import {Observable} from 'rxjs';

export type ColoredChip = {
    backgroundColor: string;
    color: string;
    borderColor: string;
    text: string;
    opacity? : number;
}

export enum PolarisRoutePaths {
    POLARIS_HOME = 'home',
    MARKET_INTEL = 'market-intel',
    CHAT = 'c',
    ALERTS = 'alerts'
}

export enum AlertsRoutePaths {
    ALERT_HOME = 'home',
    ALERT_VIEW = 'a'
}

export enum RoutePaths {
    EMPTY = '',
    TRIAL = 'signup',
    MY_BRAND = 'my-brand',
    SIGNALS = 'signals',
    DATA_POINTS = 'data-points',
    MANAGE = 'manage',
    BRANDS = 'brands',
    USERS = 'users',
    ACCOUNTS = 'accounts',
    COMPETITION = 'my-competition',
    CAMPAIGNS = 'my-campaigns',
    POLARIS = 'polaris',
    AUDIENCE = 'audience',
    AI_PRESENCE = 'ai-presence',
    REPUTATION = 'reputation',
    SOCIAL_OVERVIEW = 'social-overview',
    MESSAGING = 'messaging',
    WORKSPACE_ERROR = 'workspace-error',
    ALERT_CENTER = `polaris/${PolarisRoutePaths.ALERTS}/${AlertsRoutePaths.ALERT_HOME}`,
    ALERT_VIEW = `polaris/${PolarisRoutePaths.ALERTS}/${AlertsRoutePaths.ALERT_VIEW}`
}

export enum TrialStep {
    REGISTER_EMAIL = 1,
    SELECT_BRAND = 2,
    PROFILE = 3,
    COMPLETE = 4
}

export enum MessagingRoutePaths {
    MARKETING_REPORT = 'marketing-report',
    CREATIVE_GALLERY = 'creative-gallery'
}

export enum FormMode {
    ADD = 'add',
    EDIT = 'edit'
}


export type WidgetValueField = '' | 'share' | 'score' | 'value'

export interface BaseChartData {
    name?: string;
    key?: string;
    y?: any;
    date?: string;
  }

  export type ChartData = BaseChartData & {
    [K in WidgetValueField]?: number;
  };

export interface TableHeaderParams extends IHeaderParams{
  tooltip?: string;
  sortable?: boolean;
  field?: InventoryQualityTableColumns;
}

export enum BrandColors {
    MY_BRAND = "#840456",
    BRAND_1 = "#04857E",
    BRAND_2 = "#FF8039",
    BRAND_3 = "#999FCC",
    BRAND_4 = "#FFCC66",
    BRAND_5 = "#9FB264",
    BRAND_6 = "#F6CDBA",
    BRAND_7 = "#2661BF",
    BRAND_8 = "#D45B93",
    BRAND_9 = "#9C7F63",
    BRAND_10 = "#084D4C"
};


export const ATTENTION_METRIC_NAME = 'TruAttention™';
